import Icon from '@ant-design/icons'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { Checkbox, Tag } from 'antd'
import clsx from 'clsx'

import styles from './workspace-filter-item.module.scss'
import { getIcon, IconEnum } from '../../../../../assets/icons'
import { MilestoneType } from '../../../../../entities/workflow/constants/workflow.constants'
import { MilestoneItem } from '../../../../../entities/workflow/types/workflow.types'

type WorkspaceFilterItemType = {
  item: MilestoneItem
  isChecked: boolean
  onToggle: (id: number) => void
}

export const WorkspaceFilterItem = ({ item, isChecked, onToggle }: WorkspaceFilterItemType) => {
  const { attributes, listeners, isDragging, setNodeRef, transform, transition } = useSortable({ id: item.id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 100 : 1,
    opacity: isDragging ? 0.5 : 1,
  }

  return (
    <div
      ref={setNodeRef}
      className={clsx('py-2 px-3 rounded', styles.itemWrap, {
        [styles.activityItem]: item.type === MilestoneType.Activity,
        [styles.milestoneItem]: item.type === MilestoneType.Milestone,
      })}
      style={style}
    >
      <Tag
        className={styles.itemTag}
        icon={
          <Icon
            className={clsx(styles.itemDrag)}
            component={getIcon(IconEnum.DragDots)}
            {...attributes}
            {...listeners}
          />
        }
      >
        <Checkbox
          checked={isChecked}
          onChange={() => onToggle(item.id)}
        >
          {item.name}
        </Checkbox>
      </Tag>
    </div>
  )
}
